import { Box, Icon, IconButton, Link } from '@mui/material';
import { FC } from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

export const Footer: FC = () => {
	return (
		<footer id="footer">
			<Box
				className="footer-container"
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', md: 'row' },
					justifyContent: 'space-between',
					fontSize: '.9rem',
					padding: { xs: '10px', sm: '20px' },
					alignItems: 'start',
					gap: 4,
					minHeight: '70px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: { xs: 'column', sm: 'row' },
						alignItems: 'start',
						// justifyContent: 'center',
						gap: '20px',
					}}
				>
					<img className="logo-footer" src="/img/EAS-logo.svg" alt="" />
					<div>
						EAS Solution is a VAT and customs specialist and SaaS provider.
						<br />
						Our mission is to resolve EU regulatory challenges for e&#8209;commerce actors and
						logistics operators
					</div>
				</Box>

				<Box
					// className="footer-menu-col"
					sx={{
						// textAlign: 'right',
						display: 'flex',
						flexDirection: { sm: 'row', xs: 'column' },
						justifyContent: { md: 'space-between', xs: 'start' },
						gap: '10px',
						alignItems: { sm: 'center', xs: 'start' },
						mt: '-10px',
					}}
				>
					<a href="https://help.easproject.com/">EAS&nbsp;Help&nbsp;Center</a>
					<a href="https://easproject.com/">EAS&nbsp;Website</a>
					<Box
						className="footer-menu-col"
						sx={{
							// textAlign: 'right',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							// gap: '4px',
							alignItems: 'center',
						}}
					>
						<IconButton
							onClick={() => window.open('https://www.facebook.com/easproject', '_blank')}
						>
							<FacebookIcon color="primary" sx={{ fontSize: { xs: '1.5rem', sm: '1.5rem' } }} />
						</IconButton>
						<IconButton
							onClick={() => window.open('https://www.instagram.com/eascompliance', '_blank')}
						>
							<InstagramIcon color="primary" sx={{ fontSize: { xs: '1.5rem', sm: '1.5rem' } }} />
						</IconButton>
						<IconButton
							onClick={() =>
								window.open('https://www.linkedin.com/company/eas-project-oy', '_blank')
							}
						>
							<LinkedInIcon color="primary" sx={{ fontSize: { xs: '1.5rem', sm: '1.5rem' } }} />
						</IconButton>
						<IconButton onClick={() => window.open('https://twitter.com/EAScompliance', '_blank')}>
							<XIcon color="primary" sx={{ fontSize: { xs: '1.5rem', sm: '1.5rem' } }} />
						</IconButton>
					</Box>
				</Box>
			</Box>
			<section className="footer-copirigt">
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						// alignItems: 'center',
						gap: '20px',
						fontSize: '.8rem',
					}}
				>
					<Box>© Easy Access System Europe OU. All rights reserved </Box>
					<Box
						sx={{
							display: 'flex',
							gap: '20px',
						}}
					>
						<Box>
							<Link color="#ffffffd0" underline="none" href="https://easproject.com/cookie-policy/">
								Cookie policy
							</Link>
						</Box>
						<Box>
							<Link color="#ffffffd0" underline="none" href="https://easproject.com/privacy-policy">
								Privacy policy
							</Link>
						</Box>
					</Box>
				</Box>
			</section>
		</footer>
	);
};
